import type { Error } from '../types';

export const lengthRange =
  (min: number, max: number, message?: Error['message']) =>
  (value: string): Error => ({
    valid: value?.length >= min && value?.length <= max,
    message
  });
